import { BottomSheet, BottomSheetIllustrationContent } from "@clipboard-health/ui-components";
import { type UseModalState } from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

interface OrientationFailureAlertBottomSheetProps {
  modalState: UseModalState;
  scheduledForTimeString: string;
  retakeAllowedAfterTimeString: string;
}

export function OrientationFailureAlertBottomSheet(props: OrientationFailureAlertBottomSheetProps) {
  const { modalState, scheduledForTimeString, retakeAllowedAfterTimeString } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" sx={{ marginTop: 5, marginBottom: 5 }}>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.CLIPBOARD_ORIENTATION_FAILURE_ALERT_DISMISSED);
              modalState.closeModal();
            }}
          >
            Continue
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="error"
        title="You missed your Demo Shift"
        description={`You missed the Demo Shift you scheduled for ${scheduledForTimeString}. You can schedule
          again after ${retakeAllowedAfterTimeString}.`}
      />
    </BottomSheet>
  );
}
